<template>
<div class="alert" :class="'alert-'+variant" role="alert">
    <div v-if="has_icon" class="alert-icon">
        <slot name="icon"></slot>
    </div>                    
    <div class="alert-text">
        <slot></slot>
    </div>
    <div v-if="has_close" class="alert-close">
        <kt-button class="close" data-dismiss="alert" aria-label="Close">
            <kt-span aria-hidden="true">
                <kt-icon type="la" name=close />
            </kt-span>
        </kt-button>
    </div>
</div>  
</template>

<script>
export default {
    props: {
        is_light: {
            type: Boolean,
            default: false,
        },
        is_elevate: {
            type: Boolean,
            default: false,
        },
        is_bold: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: 'primary',
        },
        state: {
            type: String,
            default: 'basic', // basic|outline|solid
        },
        has_close: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        _class: function() {
            let _class = []

            _class.push('alert-'+this.variant)

            if(this.state !== 'basic') {
                _class.push(this.state+'-'+this.variant)
            }

            if(this.is_light === true) {
                _class.push('alert-light')
            }

            if(this.is_elevate) {
                _class.push('alert-elevate')
            }

            if(this.is_bold) {
                _class.push('alert-bold')
            }

            return _class
        },
        has_icon: function() {
            return !!this.$slots.icon
        }
    }
}
</script>